import { useContext } from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";
import { DatePicker, Form, Input, Col } from "antd";

const VehiclePmisplusFields = (props) => {
    const shouldShow = shouldShowComponent(
        config.project,
        "VehiclePmisplusFields"
    );
    const storeContext = useContext(StoreContext); // Use the context here

    if (!shouldShow) {
        return null; // Do not render if the condition is not met
    }

    return (
        <>
            <Col span={12} className="formColumnClass">
                <Form.Item
                    name="fuelConsumption"
                    label={storeContext.translate("_VEHICLE_MILAGE_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="orderNo"
                    label={storeContext.translate("_ORDER_NO_")}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="groupNo"
                    label={storeContext.translate("_CC_GROUPNO_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="monthlyDistanceLimit"
                    // label="monthly distance Limit"
                    label={storeContext.translate(
                        "_MONTHLY_DISTANCE_LIMIT_"
                    )}
                // initialValue={20}
                >
                    <Input />
                </Form.Item>


                <Form.Item
                    name="lastBatteryDate"
                    label={storeContext.translate(
                        "_FLEET_VEHICLE_VEHICLEDETAIL_LASTBATTERY_"
                    )}
                    rules={[{ type: Date }]}
                >
                    <DatePicker
                        style={{ width: "100%", height: "40px" }}
                        format={"YYYY-MM-DD"}
                    />
                </Form.Item>

                <Form.Item
                    name="serviceIntervalDay"
                    label={storeContext.translate(
                        "_FLEET_VEHICLE_VEHICLEDETAIL_SERVICEEXPIRE_DAYS_"
                    )}
                >
                    <Input
                        onChange={(e) =>
                            props.validateFieldsValue(
                                e.target.value,
                                "serviceIntervalDay"
                            )
                        }
                    />
                </Form.Item>

                <Form.Item
                    name="workingHours"
                    label={storeContext.translate(
                        "_DAILY_WORKING_HOURS_"
                    )}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="hourMeterReading"
                    label={storeContext.translate(
                        "_HOURS_METER_READING_"
                    )}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="totalHoursMeterReading"
                    label={storeContext.translate(
                        "_TOTAL_HOURS_METER_READING_"
                    )}
                >
                    <Input readOnly={true} />
                </Form.Item>

                <Form.Item
                    name="capacity"
                    //  label="Fuel Capacity"
                    label={storeContext.translate(
                        "_FLEET_VEHICLE_VEHICLEDETAIL_FUELCAPACITY_"
                    )}
                >
                    <Input
                        placeholder={storeContext.translate(
                            "_FLEET_VEHICLE_VEHICLEDETAIL_FUELCAPACITY_"
                        )}

                        onChange={(e) =>
                            props.validateFieldsValue(
                                e.target.value,
                                "capacity"
                            )
                        }
                    />
                </Form.Item>

            </Col>
            <Col span={12} className="formColumnClass">


                <Form.Item
                    name="maxDistance"
                    label={storeContext.translate("_MAXIMUM_DISTANCE_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="minDistance"
                    label={storeContext.translate("_MINIMUM_DISTANCE_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="password"
                    // label="Hour Meter Reading"
                    label={storeContext.translate("_FLEET_LOGIN_PASSWORDLBL_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="UDID"
                    // label="Hour Meter Reading"
                    label={storeContext.translate("_DEVICE_UDID_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="UDID2"
                    // label="Hour Meter Reading"
                    label={storeContext.translate("_DEVICE_UDID2_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="dailyRent"
                    label={storeContext.translate("_DAILY_RENT_")}
                >
                    <Input onChange={(e) => props.validateNumberAndDecimal(e.target.value, "dailyRent")} />
                </Form.Item>

                <Form.Item
                    name="seatCapacity"
                    // label="Hour Meter Reading"
                    label={storeContext.translate("_SEATING_CAPACITY_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="noOfBaggage"
                    // label="Hour Meter Reading"
                    label={storeContext.translate("_MAX_NO_BAGGAGE_")}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="harshAcce"
                    // label="Hour Meter Reading"
                    label={storeContext.translate("_HARSH_ACCELERATION_")}
                    initialValue={2}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="harshBrack"
                    // label="Hour Meter Reading"
                    label={storeContext.translate("_HARSH_BRACKING_")}
                    initialValue={2}
                >
                    <Input />
                </Form.Item>
            </Col>
        </>
    );
};

VehiclePmisplusFields.contextType = StoreContext;
export default observer(withRouter(VehiclePmisplusFields));
